export const PageUrlRu = {
  cargo: {
     url: "/cargo/cargoShipmentManagement",
  }
};
